export enum InvoiceRowUnit {
    HOUR = 'HOUR',
    PERSON = 'PERSON',
    PIECE = 'PIECE',
    NO_UNIT = 'NO_UNIT',
}
